module.exports = __webpack_public_path__ + "img/personal-counter-dropdown-video-firstsearch.50054a7.png";